import(/* webpackMode: "eager" */ "/app/apps/web/src/app/match/page.tsx");
